import * as React from 'react'

// @ts-ignore
import chevronDown from '../../../assets/chevron-down.svg'

// @ts-ignore
import styles from './Navigation.module.scss'

export const menuItems = [
  {
    path: '/avveckla-aktiebolag',
    title: 'Avveckla Bolag',
    hasChevron: true,
    subMenu: [
      {
        path: '/avveckla-aktiebolag',
        title: 'Avveckla - Börja här!'
      },
      {
        path: '/avveckla-aktiebolag/en-av-vara-medarbetare-berattar-om-avveckling',
        title: 'Frågor och Svar'
      },
      {
        path: '/avveckla-aktiebolag/snabbavveckling-av-aktiebolag',
        title: 'Hur går det till?'
      },
      {
        path:
          '/avveckla-aktiebolag/materialinsamling-vad-vi-behover-for-att-kunna-kopa-bolaget-av-er',
        title: 'Materiallinsamling'
      }, {
        path:
          '/avveckla-aktiebolag/pris',
        title: 'Kostnadsfri Offert Inom 2h!'
      }
    ]
  },
  {
    path: '/kopa-lagerbolag',
    title: 'Lagerbolag',
    hasChevron: true,
    subMenu: [
      {
        path: '/kopa-lagerbolag',
        title: 'Lagerbolag - Börja här!'
      },
      {
        path: '/kopa-lagerbolag/vara-medarbetare-berattar-om-lagerbolag',
        title: 'Frågor och Svar'
      },
      {
        path: '/kopa-lagerbolag/hur-gar-det-till-att-kopa-lagerbolag',
        title: 'Hur går det till?'
      },
      {
        path: '/kopa-lagerbolag/pris',
        title: 'Beställ Nu - 2h leveranstid!'
      }
    ]
  },
  {
    path: '/medarbetare',
    title: 'Våra Medarbetare'
  },
  {
    path: '/om-oss',
    title: 'Om Oss'
  },
  {
    path: '/jobba-hos-oss',
    title: 'Jobba Hos Oss'
  },
  {
    path: '/artiklar',
    title: 'Mer Information',
    hasChevron: true,
    subMenu: [
      {
        path: '/avveckla-aktiebolag/likvidera-aktiebolag',
        title: 'Likvidera aktiebolag'
      },
      {
        path: '/avveckla-aktiebolag/snabbavveckling',
        title: 'Snabbavveckling'
      },
      {
        path: '/avveckla-aktiebolag/salja-aktiebolag',
        title: 'Sälja ditt aktiebolag?'
      },
      {
        path: '/kopa-lagerbolag/kopa-aktiebolag',
        title: 'Köpa aktiebolag'
      },
      {
        path: '/kopa-lagerbolag/starta-aktiebolag',
        title: 'Att starta ett aktiebolag'
      },
      {
        path: '/artiklar',
        title: 'Fler artiklar...'
      }
    ]
  },
  {
    path: '/kontakta-oss',
    title: 'Kontakta Oss'
  },
  {
    path: 'https://citadellet.konfident.io/',
    title: 'Logga In'
  }
]

const ListLink = props => {
  const Link = props.LinkComponent

  return (
    <li className={styles.subnav}>
      <div className={styles.dropdown}>
        <Link to={props.to} className={styles.navLink}>
          {props.children}{' '}
          {props.hasChevron ? (
            <img src={chevronDown} alt='chevron down icon' className={styles.chevron} />
          ) : null}
        </Link>
        {props.hasChevron && (
          <div className={styles.dropdownContainer}>
            <div className={styles.dropdownContent}>
              {props?.subMenu?.map(item => (
                <Link key={`sub-menu-link__${item.title}`} to={item.path}>{item.title}</Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </li>
  )
}

const Navigation = ({ linkComponent }) => {

  return (
    <nav className={styles.Navigation}>
      <ul className={styles.linksList}>
        { menuItems.map((menuItem, index) => (
          <ListLink
            key={`header-menu__${index}__${menuItem.title}`}
            LinkComponent={linkComponent}
            to={menuItem.path}
            hasChevron={menuItem.hasChevron}
            subMenu={menuItem.subMenu}
          >
            {menuItem.title}
          </ListLink>
        )) }
      </ul>
    </nav>
  )
}

export default Navigation
